import { PulpAPI } from './pulp';

class API extends PulpAPI {
  apiPath = 'pulp_container/namespaces/';
  sortParam = 'sort';

  listRoles(id, params?) {
    return super.list(params, this.apiPath + id + '/list_roles/');
  }

  addRole(id, role) {
    return super.create(role, this.apiPath + id + '/add_role/');
  }

  myPermissions(id, params?) {
    return super.list(params, this.apiPath + id + '/my_permissions/');
  }

  removeRole(id, role) {
    return super.create(role, this.apiPath + id + '/remove_role/');
  }
}

export const ExecutionEnvironmentNamespaceAPI = new API();
